var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZoomInMap = function SvgZoomInMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "zoom_in_map_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#zoom_in_map_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7 18.4-2.4 2.4a.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275.95.95 0 0 1-.275-.7q0-.426.275-.7L5.6 17H4a.97.97 0 0 1-.713-.288A.97.97 0 0 1 3 16q0-.426.287-.713A.97.97 0 0 1 4 15h4q.424 0 .712.287Q9 15.575 9 16v4q0 .424-.288.712A.97.97 0 0 1 8 21a.97.97 0 0 1-.713-.288A.97.97 0 0 1 7 20zm10 0V20q0 .424-.288.712A.97.97 0 0 1 16 21a.97.97 0 0 1-.713-.288A.97.97 0 0 1 15 20v-4q0-.426.287-.713A.97.97 0 0 1 16 15h4q.424 0 .712.287.288.288.288.713 0 .424-.288.712A.97.97 0 0 1 20 17h-1.6l2.4 2.4a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275zM5.6 7 3.2 4.6a.95.95 0 0 1-.275-.7q0-.426.275-.7a.95.95 0 0 1 .7-.275q.425 0 .7.275L7 5.6V4q0-.425.287-.713A.97.97 0 0 1 8 3q.424 0 .712.287Q9 3.575 9 4v4q0 .424-.288.712A.97.97 0 0 1 8 9H4a.97.97 0 0 1-.713-.288A.97.97 0 0 1 3 8q0-.426.287-.713A.97.97 0 0 1 4 7zm12.8 0H20q.424 0 .712.287Q21 7.575 21 8q0 .424-.288.712A.97.97 0 0 1 20 9h-4a.97.97 0 0 1-.713-.288A.97.97 0 0 1 15 8V4q0-.425.287-.713A.97.97 0 0 1 16 3q.424 0 .712.287Q17 3.575 17 4v1.6l2.4-2.4a.95.95 0 0 1 .7-.275q.425 0 .7.275a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7z"
  }))));
};
export default SvgZoomInMap;